/*
	Insert Map.
	Google Maps - Javascript model.
*/
Maps_embedded = {
	p_map_target : '.map-embed',
	p_map_wrapper_target : '.map-embed-wrapper',
	init : function()
	{
		// Handle disabling scroll events appropriately for embedded maps. 
		
		// Set the mouse events to none when doc is ready
		///jQuery(Maps_embedded.p_map_target).addClass('scrolloff');
        
        // Lock it when mouse up
        jQuery(Maps_embedded.p_map_wrapper_target).on("mouseup",function(){          
            ///jQuery(Maps_embedded.p_map_target).addClass('scrolloff'); 
            //somehow the mouseup event doesn't get call...
        });
        
        // When mouse down, set the mouse events free
        jQuery(Maps_embedded.p_map_wrapper_target).on("mousedown",function(){
            ///jQuery(Maps_embedded.p_map_target).removeClass('scrolloff');
        });
        
        // Becuase the mouse up doesn't work...
        // set the pointer events to none when mouse leaves the map area
        // or you can do it on some other event
        jQuery(Maps_embedded.p_map_target).mouseleave(function () {              
            ///jQuery(Maps_embedded.p_map_target).addClass('scrolloff');
        });
	}
};

jQuery(document).ready(function(jQuery){
	
	Maps_embedded.init();
	
});